// Librerías
import React from 'react';
import { Helmet } from 'react-helmet';
// Componentes
import Footer from '../components/Footer/Footer';
import Navbar from '../components/Navbar/Navbar';
import Terms from '../components/LandingPage/Terms';

const TermsContainer = () => {
  return(
    <div>
        <Helmet>
          <title>Términos y Condiciones | Alohar</title>
          <meta
            name="description"
            content="Consulta los términos y condiciones de uso de Alohar para reservas, pagos y obligaciones de usuarios."
          />
          <link rel="canonical" href="https://alohar.me/terminos" />
        </Helmet>
        <Navbar addSearch={false} hideAlohadorButtons={true} hideSearchButtons={true}/>
        <Terms />
        <Footer />
    </div>
  );
}

export default TermsContainer;